// Import supported languages
import UI_ar from "./ar/translation.json";
import UI_de from "./de/translation.json";
import UI_en from "./en/translation.json";
import UI_es from "./es/translation.json";
import UI_fr from "./fr/translation.json";
import UI_it from "./it/translation.json";
import UI_ja from "./ja/translation.json";
import UI_ko from "./ko/translation.json";
import UI_nl from "./nl/translation.json";
import UI_pt from "./pt/translation.json";
import UI_tr from "./tr/translation.json";
import UI_zh from "./zh/translation.json";
import UI_zu from "./zu/translation.json";
import UI_uk from "./uk/translation.json";

const locales = {
    "ar": UI_ar,
    "de": UI_de,
    "en": UI_en,
    "es": UI_es,
    "fr": UI_fr,
    "it": UI_it,
    "ja": UI_ja,
    "ko": UI_ko,
    "nl": UI_nl,
    "pt": UI_pt,
    "tr": UI_tr,
    "zh": UI_zh,
    "zu": UI_zu,
    "uk": UI_uk
}

export default locales;